import { useQuery } from '@tanstack/react-query';
import { tenantApi } from './api-client';
import { useAuth } from './auth-context';

/**
 * A verified identity (password login, SSO, or a valid API key) is not the same as
 * workspace access — the API is deny-by-default (no membership => NOT_A_MEMBER,
 * no auto-provisioning). This hook confirms the current credential can actually
 * reach tenant data before rendering the app, so a signed-in-but-not-a-member
 * user gets a calm explanation instead of a screen full of failed requests.
 */
export function useWorkspaceAccess() {
  const { isAuthenticated } = useAuth();
  const query = useQuery({
    queryKey: ['tenant-me'],
    queryFn: () => tenantApi.me(),
    enabled: isAuthenticated,
    retry: false,
  });
  return { ...query, checked: !isAuthenticated || query.isSuccess || query.isError };
}
